const shelterList = [
  {
    name: "강릉시 동물사랑센터",
    code: "342420201500001",
    org_cd: "4200000",
    org_Nm: "강원도 강릉시",
  },
  {
    name: "유기견임시보호소",
    code: "342434202100001",
    org_cd: "4340000",
    org_Nm: "강원도 고성군",
  },
  {
    name: "동해시유기동물보호소",
    code: "342421201000001",
    org_cd: "4210000",
    org_Nm: "강원도 동해시",
  },
  {
    name: "삼척동물병원",
    code: "342424201900001",
    org_cd: "4240000",
    org_Nm: "강원도 삼척시",
  },
  {
    name: "두타동물병원",
    code: "342424201800001",
    org_cd: "4240000",
    org_Nm: "강원도 삼척시",
  },
  {
    name: "삼척시동물보호센터",
    code: "342424201300001",
    org_cd: "4240000",
    org_Nm: "강원도 삼척시",
  },
  {
    name: "속초시유기동물보호소",
    code: "342423201200001",
    org_cd: "4230000",
    org_Nm: "강원도 속초시",
  },
  {
    name: "양구군유기동물보호소",
    code: "342432201000001",
    org_cd: "4320000",
    org_Nm: "강원도 양구군",
  },
  {
    name: "양양군유기동물보호소",
    code: "342435201000001",
    org_cd: "4350000",
    org_Nm: "강원도 양양군",
  },
  {
    name: "영월군위탁동물보호소",
    code: "342427201400001",
    org_cd: "4270000",
    org_Nm: "강원도 영월군",
  },
  {
    name: "수호동물병원",
    code: "342427202000001",
    org_cd: "4270000",
    org_Nm: "강원도 영월군",
  },
  {
    name: "축협동물병원",
    code: "342427202200001",
    org_cd: "4270000",
    org_Nm: "강원도 영월군",
  },
  {
    name: "원주유기동물보호센터",
    code: "342419200900001",
    org_cd: "4190000",
    org_Nm: "강원도 원주시",
  },
  {
    name: "인제군유기동물보호소",
    code: "342433201300001",
    org_cd: "4330000",
    org_Nm: "강원도 인제군",
  },
  {
    name: "다나동물병원",
    code: "342429201300002",
    org_cd: "4290000",
    org_Nm: "강원도 정선군",
  },
  {
    name: "정선가축병원",
    code: "342429201400001",
    org_cd: "4290000",
    org_Nm: "강원도 정선군",
  },
  {
    name: "성일동물병원",
    code: "342430200900001",
    org_cd: "4300000",
    org_Nm: "강원도 철원군",
  },
  {
    name: "철원군",
    code: "342430201900001",
    org_cd: "4300000",
    org_Nm: "강원도 철원군",
  },
  {
    name: "춘천시 동물보호센터",
    code: "342418201300001",
    org_cd: "4180000",
    org_Nm: "강원도 춘천시",
  },
  {
    name: "태백유기동물",
    code: "342422200900001",
    org_cd: "4220000",
    org_Nm: "강원도 태백시",
  },
  {
    name: "평창군유기동물보호소",
    code: "342428200900001",
    org_cd: "4280000",
    org_Nm: "강원도 평창군",
  },
  {
    name: "홍천군유기동물보호소",
    code: "342425201400001",
    org_cd: "4250000",
    org_Nm: "강원도 홍천군",
  },
  {
    name: "화천군농업기술센터",
    code: "342431201300001",
    org_cd: "4310000",
    org_Nm: "강원도 화천군",
  },
  {
    name: "횡성유기동물보호센터",
    code: "342426201600001",
    org_cd: "4260000",
    org_Nm: "강원도 횡성군",
  },
  {
    name: "가평군유기동물보호소",
    code: "341416200900001",
    org_cd: "4160000",
    org_Nm: "경기도 가평군",
  },
  {
    name: "고양시동물보호센터",
    code: "341394201400001",
    org_cd: "3940000",
    org_Nm: "경기도 고양시",
  },
  {
    name: "하은동물병원",
    code: "341397202100002",
    org_cd: "3970000",
    org_Nm: "경기도 과천시",
  },
  {
    name: "한국야생동물보호협회",
    code: "341397202100001",
    org_cd: "3970000",
    org_Nm: "경기도 과천시",
  },
  {
    name: "한국야생동물보호협회",
    code: "341390201300001",
    org_cd: "3900000",
    org_Nm: "경기도 광명시",
  },
  {
    name: "한국야생동물보호협회",
    code: "341402202100001",
    org_cd: "4020000",
    org_Nm: "경기도 군포시",
  },
  {
    name: "한국야생동물보호협회",
    code: "341393200900001",
    org_cd: "3930000",
    org_Nm: "경기도 안산시",
  },
  {
    name: "한국야생동물보호협회",
    code: "341383201300001",
    org_cd: "3830000",
    org_Nm: "경기도 안양시",
  },
  {
    name: "한국야생동물보호협회",
    code: "341559200900001",
    org_cd: "5590000",
    org_Nm: "경기도 양주시",
  },
  {
    name: "한국야생동물보호협회",
    code: "341414201300001",
    org_cd: "4140000",
    org_Nm: "경기도 연천군",
  },
  {
    name: "한국야생동물보호협회",
    code: "341403202100001",
    org_cd: "4030000",
    org_Nm: "경기도 의왕시",
  },
  {
    name: "광명반함센터",
    code: "341390202100002",
    org_cd: "3900000",
    org_Nm: "경기도 광명시",
  },
  {
    name: "광주TNR동물병원송정",
    code: "341554201300008",
    org_cd: "5540000",
    org_Nm: "경기도 광주시",
  },
  {
    name: "광주TNR동물병원초월",
    code: "341554201900001",
    org_cd: "5540000",
    org_Nm: "경기도 광주시",
  },
  {
    name: "한국동물구조관리협회",
    code: "341398200900001",
    org_cd: "3980000",
    org_Nm: "경기도 구리시",
  },
  {
    name: "한국동물구조관리협회",
    code: "341409201400001",
    org_cd: "4090000",
    org_Nm: "경기도 김포시",
  },
  {
    name: "한국동물구조관리협회",
    code: "341392201300001",
    org_cd: "3920000",
    org_Nm: "경기도 동두천시",
  },
  {
    name: "한국동물구조관리협회",
    code: "341382200900001",
    org_cd: "3820000",
    org_Nm: "경기도 의정부시",
  },
  {
    name: "한국동물구조관리협회",
    code: "341406202200002",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "한국동물구조관리협회",
    code: "341560201000002",
    org_cd: "5600000",
    org_Nm: "경기도 포천시",
  },
  {
    name: "스타동물병원",
    code: "341398202200001",
    org_cd: "3980000",
    org_Nm: "경기도 구리시",
  },
  {
    name: "남양주동물보호협회",
    code: "341399201500001",
    org_cd: "3990000",
    org_Nm: "경기도 남양주시",
  },
  {
    name: "동인동물병원",
    code: "341399201900001",
    org_cd: "3990000",
    org_Nm: "경기도 남양주시",
  },
  {
    name: "장현동물병원",
    code: "341399201900003",
    org_cd: "3990000",
    org_Nm: "경기도 남양주시",
  },
  {
    name: "25시동물병원",
    code: "341399202200001",
    org_cd: "3990000",
    org_Nm: "경기도 남양주시",
  },
  {
    name: "남양주시동물보호센터",
    code: "341399202200002",
    org_cd: "3990000",
    org_Nm: "경기도 남양주시",
  },
  {
    name: "대관령동물병원",
    code: "341399202100001",
    org_cd: "3990000",
    org_Nm: "경기도 남양주시",
  },
  {
    name: "러브펫동물병원",
    code: "341392202000002",
    org_cd: "3920000",
    org_Nm: "경기도 동두천시",
  },
  {
    name: "24시아이동물메디컬",
    code: "341386200900001",
    org_cd: "3860000",
    org_Nm: "경기도 부천시",
  },
  {
    name: "부천시수의사회",
    code: "341386201500001",
    org_cd: "3860000",
    org_Nm: "경기도 부천시",
  },
  {
    name: "가나동물병원",
    code: "341386201800001",
    org_cd: "3860000",
    org_Nm: "경기도 부천시",
  },
  {
    name: "cj동물병원",
    code: "341386201800004",
    org_cd: "3860000",
    org_Nm: "경기도 부천시",
  },
  {
    name: "가야동물병원",
    code: "341386201900003",
    org_cd: "3860000",
    org_Nm: "경기도 부천시",
  },
  {
    name: "펫앤쉘터동물병원",
    code: "341378201300002",
    org_cd: "3780000",
    org_Nm: "경기도 성남시",
  },
  {
    name: "우리동물병원",
    code: "341378201500001",
    org_cd: "3780000",
    org_Nm: "경기도 성남시",
  },
  {
    name: "우리들 동물병원",
    code: "341378201800001",
    org_cd: "3780000",
    org_Nm: "경기도 성남시",
  },
  {
    name: "수원시 동물보호센터",
    code: "341374202000001",
    org_cd: "3740000",
    org_Nm: "경기도 수원시",
  },
  {
    name: "호수동물병원",
    code: "341401201900001",
    org_cd: "4010000",
    org_Nm: "경기도 시흥시",
  },
  {
    name: "닥터원동물병원",
    code: "341401202100001",
    org_cd: "4010000",
    org_Nm: "경기도 시흥시",
  },
  {
    name: "목감동물병원",
    code: "341401202000002",
    org_cd: "4010000",
    org_Nm: "경기도 시흥시",
  },
  {
    name: "시흥동물누리보호센터",
    code: "341401202200001",
    org_cd: "4010000",
    org_Nm: "경기도 시흥시",
  },
  {
    name: "스타캣츠",
    code: "341393201900001",
    org_cd: "3930000",
    org_Nm: "경기도 안산시",
  },
  {
    name: "이성준동물병원",
    code: "341408200900001",
    org_cd: "4080000",
    org_Nm: "경기도 안성시",
  },
  {
    name: "양평군유기동물보호소",
    code: "341417201800001",
    org_cd: "4170000",
    org_Nm: "경기도 양평군",
  },
  {
    name: "위더스 동물보호센터",
    code: "341570201900003",
    org_cd: "5700000",
    org_Nm: "경기도 여주시",
  },
  {
    name: "위더스 동물보호센터",
    code: "341407201900001",
    org_cd: "4070000",
    org_Nm: "경기도 이천시",
  },
  {
    name: "오산 유기동물보호소",
    code: "341400200900001",
    org_cd: "4000000",
    org_Nm: "경기도 오산시",
  },
  {
    name: "용인시 동물보호센터",
    code: "341405201800001",
    org_cd: "4050000",
    org_Nm: "경기도 용인시",
  },
  {
    name: "의왕시청",
    code: "341403202000001",
    org_cd: "4030000",
    org_Nm: "경기도 의왕시",
  },
  {
    name: "청계종합동물병원",
    code: "341403202200002",
    org_cd: "4030000",
    org_Nm: "경기도 의왕시",
  },
  {
    name: "늘솜동물병원",
    code: "341403202200001",
    org_cd: "4030000",
    org_Nm: "경기도 의왕시",
  },
  {
    name: "세이프캣티엔알연합",
    code: "341382201700001",
    org_cd: "3820000",
    org_Nm: "경기도 의정부시",
  },
  {
    name: "고방동물병원",
    code: "341407202000001",
    org_cd: "4070000",
    org_Nm: "경기도 이천시",
  },
  {
    name: "행복한동물병원",
    code: "341406201300006",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "나은동물병원",
    code: "341406201300009",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "파주24시동물병원",
    code: "341406201300005",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "웰니스클리닉",
    code: "341406201500002",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "야당동물병원",
    code: "341406201700010",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "가온동물병원",
    code: "341406201700002",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "로뎀동물병원",
    code: "341406201700009",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "금릉동물병원",
    code: "341406201700001",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "미엘동물병원",
    code: "341406201700003",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "문산동물병원",
    code: "341406201300003",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "고려동물병원",
    code: "341406202200001",
    org_cd: "4060000",
    org_Nm: "경기도 파주시",
  },
  {
    name: "평택시유기동물보호소",
    code: "341391200900001",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "코리아 동물병원",
    code: "341391201800002",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "필립 동물병원",
    code: "341391201800003",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "강남동물병원",
    code: "341391201900001",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "two현동물병원",
    code: "341391201900002",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "안중중앙동물병원",
    code: "341391201900004",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "PET25시 동물병원",
    code: "341391201900005",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "펫필드동물병원",
    code: "341391201900003",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "쿨펫동물병원",
    code: "341391202000002",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "심재훈동물병원",
    code: "341391202100001",
    org_cd: "3910000",
    org_Nm: "경기도 평택시",
  },
  {
    name: "오암동물병원",
    code: "341391202000001",
    org_cd: "3910000",
    org_Nm: "경기도 ㅕㅍㅇ택시",
  },
  {
    name: "하남동물병원",
    code: "341404201700002",
    org_cd: "4040000",
    org_Nm: "경기도 하남시",
  },
  {
    name: "남양동물보호센터",
    code: "341553201700001",
    org_cd: "5530000",
    org_Nm: "경기도 화성시",
  },
  {
    name: "21세기동물병원",
    code: "341553202000001",
    org_cd: "5530000",
    org_Nm: "경기도 화성시",
  },
  {
    name: "신동물메디컬센터",
    code: "341553202100001",
    org_cd: "5530000",
    org_Nm: "경기도 화성시",
  },
  {
    name: "거제시유기동물보호소",
    code: "348537200900002",
    org_cd: "5370000",
    org_Nm: "경상남도 거제시",
  },
  {
    name: "거창유기동물보호센터",
    code: "348547202200001",
    org_cd: "5470000",
    org_Nm: "경상남도 거창군",
  },
  {
    name: "고성군유기동물보호소",
    code: "348542202000002",
    org_cd: "5420000",
    org_Nm: "경상남도 고성군",
  },
  {
    name: "유기동물및관리협회",
    code: "348535201200001",
    org_cd: "5350000",
    org_Nm: "경상남도 김해시",
  },
  {
    name: "(사)부산동물구조협회",
    code: "348535201800001",
    org_cd: "5350000",
    org_Nm: "경상남도 김해시",
  },
  {
    name: "누리동물병원",
    code: "348535202100001",
    org_cd: "5350000",
    org_Nm: "경상남도 김해시",
  },
  {
    name: "부산동물보호센터",
    code: "348535202200001",
    org_cd: "5350000",
    org_Nm: "경상남도 김해시",
  },
  {
    name: "남해군유기동물보호소",
    code: "348543201300001",
    org_cd: "5430000",
    org_Nm: "경상남도 남해군",
  },
  {
    name: "밀양시동물보호센터",
    code: "348536201800001",
    org_cd: "5360000",
    org_Nm: "경상남도 밀양시",
  },
  {
    name: "사천시 동물보호센터",
    code: "348534202000001",
    org_cd: "5340000",
    org_Nm: "경상남도 사천시",
  },
  {
    name: "산청동물보호센터",
    code: "348545201100002",
    org_cd: "5450000",
    org_Nm: "경상남도 산청군",
  },
  {
    name: "양산시 동물보호센터",
    code: "348538200900001",
    org_cd: "5380000",
    org_Nm: "경상남도 양산시",
  },
  {
    name: "만하농장",
    code: "348539201900001",
    org_cd: "5390000",
    org_Nm: "경상남도 의령군",
  },
  {
    name: "진주시유기동물보호소",
    code: "348531201000001",
    org_cd: "5310000",
    org_Nm: "경상남도 진주시",
  },
  {
    name: "창녕 유기동물보호소",
    code: "348541201300001",
    org_cd: "5410000",
    org_Nm: "경상남도 창녕군",
  },
  {
    name: "마산유기동물보호소",
    code: "348528201000001",
    org_cd: "5280000",
    org_Nm: "경상남도 창원시 마산합포회원구",
  },
  {
    name: "창원유기동물보호소",
    code: "348527200900001",
    org_cd: "5670000",
    org_Nm: "경상남도 창원시 의창성산구",
  },
  {
    name: "진해유기동물보호소",
    code: "348532200900001",
    org_cd: "5320000",
    org_Nm: "경상남도 창원시 진해구",
  },
  {
    name: "통영시동물보호센터",
    code: "348533202100001",
    org_cd: "5330000",
    org_Nm: "경상남도 통영시",
  },
  {
    name: "하동군유기동물보호소",
    code: "348544201100001",
    org_cd: "5440000",
    org_Nm: "경상남도 하동군",
  },
  {
    name: "함안군유기동물보호소",
    code: "348540200900001",
    org_cd: "5400000",
    org_Nm: "경상남도 함안군",
  },
  {
    name: "함양군위탁보호소",
    code: "348546200900001",
    org_cd: "5460000",
    org_Nm: "경상남도 함양군",
  },
  {
    name: "태민동물병원",
    code: "348548201700001",
    org_cd: "5480000",
    org_Nm: "경상남도 합천군",
  },
  {
    name: "경산시유기동물보호소",
    code: "347513201800003",
    org_cd: "5130000",
    org_Nm: "경상북도 경산시",
  },
  {
    name: "경주동물사랑보호센터",
    code: "347505201700001",
    org_cd: "5050000",
    org_Nm: "경상북도 경주시",
  },
  {
    name: "고령군 임시보호소",
    code: "347520202000001",
    org_cd: "5200000",
    org_Nm: "경상북도 고령군",
  },
  {
    name: "구미시 동물보호센터",
    code: "347508202000001",
    org_cd: "5080000",
    org_Nm: "경상북도 구미시",
  },
  {
    name: "인동동물병원",
    code: "347508202200006",
    org_cd: "5080000",
    org_Nm: "경상북도 구미시",
  },
  {
    name: "금오동물병원",
    code: "347508202200003",
    org_cd: "5080000",
    org_Nm: "경상북도 구미시",
  },
  {
    name: "정다운동물병원",
    code: "347508202200007",
    org_cd: "5080000",
    org_Nm: "경상북도 구미시",
  },
  {
    name: "봉곡동물병원",
    code: "347508202200004",
    org_cd: "5080000",
    org_Nm: "경상북도 구미시",
  },
  {
    name: "신세계동물병원",
    code: "347508202200005",
    org_cd: "5080000",
    org_Nm: "경상북도 구미시",
  },
  {
    name: "우성동물병원",
    code: "347514201300001",
    org_cd: "5140000",
    org_Nm: "경상북도 군위군",
  },
  {
    name: "김천시 동물보호센터",
    code: "347506201300001",
    org_cd: "5060000",
    org_Nm: "경상북도 김천시",
  },
  {
    name: "종합가축병원",
    code: "347512201700001",
    org_cd: "5120000",
    org_Nm: "경상북도 문경시",
  },
  {
    name: "봉화군유기동물보호소",
    code: "347524201400001",
    org_cd: "5240000",
    org_Nm: "경상북도 봉화군",
  },
  {
    name: "상주시 동물보호센터",
    code: "347511202000001",
    org_cd: "5110000",
    org_Nm: "경상북도 상주시",
  },
  {
    name: "가람동물병원",
    code: "347511202200001",
    org_cd: "5110000",
    org_Nm: "경상북도 상주시",
  },
  {
    name: "무양반려동물병원",
    code: "347511202200002",
    org_cd: "5110000",
    org_Nm: "경상북도 상주시",
  },
  {
    name: "성주유기동물보호센터",
    code: "347521201900002",
    org_cd: "5210000",
    org_Nm: "경상북도 성주군",
  },
  {
    name: "바른길동물병원",
    code: "347521202200001",
    org_cd: "5210000",
    org_Nm: "경상북도 성주군",
  },
  {
    name: "유기동물보호센터",
    code: "347507200900001",
    org_cd: "5070000",
    org_Nm: "경상북도 안동시",
  },
  {
    name: "영덕유기동물보호센터",
    code: "347518201000001",
    org_cd: "5180000",
    org_Nm: "경상북도 영덕군",
  },
  {
    name: "영덕종합동물병원",
    code: "347518202000001",
    org_cd: "5180000",
    org_Nm: "경상북도 영덕군",
  },
  {
    name: "영덕사랑동물병원",
    code: "347518202000002",
    org_cd: "5180000",
    org_Nm: "경상북도 영덕군",
  },
  {
    name: "영양군유기동물보호소",
    code: "347517201400001",
    org_cd: "5170000",
    org_Nm: "경상북도 영양군",
  },
  {
    name: "영주시 동물보호센터",
    code: "347509200900001",
    org_cd: "5090000",
    org_Nm: "경상북도 영주시",
  },
  {
    name: "영천유기동물보호센터",
    code: "347510201600001",
    org_cd: "5100000",
    org_Nm: "경상북도 영천시",
  },
  {
    name: "예천군유기동물보호소",
    code: "347523201200001",
    org_cd: "5230000",
    org_Nm: "경상북도 예천군",
  },
  {
    name: "울릉군농업기술센터",
    code: "347526201600001",
    org_cd: "5260000",
    org_Nm: "경상북도 울릉군",
  },
  {
    name: "울진군동물보호센터",
    code: "347525202100001",
    org_cd: "5250000",
    org_Nm: "경상북도 울진군",
  },
  {
    name: "의성동물보호센터",
    code: "347515201900001",
    org_cd: "5150000",
    org_Nm: "경상북도 의성군",
  },
  {
    name: "청도군동물보호소",
    code: "347519202100001",
    org_cd: "5190000",
    org_Nm: "경상북도 청도군",
  },
  {
    name: "점곡보호소",
    code: "347516202000001",
    org_cd: "5160000",
    org_Nm: "경상북도 청송군",
  },
  {
    name: "칠곡유기동물보호센터",
    code: "347522201400001",
    org_cd: "5220000",
    org_Nm: "경상북도 칠곡군",
  },
  {
    name: "영일동물플러스",
    code: "347502201600001",
    org_cd: "5020000",
    org_Nm: "경상북도 포항시",
  },
  {
    name: "광주 동물보호소",
    code: "329363201300001",
    org_cd: "3630000",
    org_Nm: "광주광역시 광산구",
  },
  {
    name: "광주광역시캣맘협의회",
    code: "329363202200001",
    org_cd: "3630000",
    org_Nm: "광주광역시 광산구",
  },
  {
    name: "광주 동물보호소",
    code: "329361201300001",
    org_cd: "3610000",
    org_Nm: "광주광역시 남구",
  },
  {
    name: "광주광역시캣맘협의회",
    code: "329361202200001",
    org_cd: "3610000",
    org_Nm: "광주광역시 남구",
  },
  {
    name: "광주 동물보호소",
    code: "329359201300001",
    org_cd: "3590000",
    org_Nm: "광주광역시 동구",
  },
  {
    name: "현동물병원",
    code: "329359201700001",
    org_cd: "3590000",
    org_Nm: "광주광역시 동구",
  },
  {
    name: "튼튼동물병원",
    code: "329359201700005",
    org_cd: "3590000",
    org_Nm: "광주광역시 동구",
  },
  {
    name: "두손너에게",
    code: "329359201700003",
    org_cd: "3590000",
    org_Nm: "광주광역시 동구",
  },
  {
    name: "광주광역시캣맘협의회",
    code: "329359202200001",
    org_cd: "3590000",
    org_Nm: "광주광역시 동구",
  },
  {
    name: "광주 동물보호소",
    code: "329362201300001",
    org_cd: "3620000",
    org_Nm: "광주광역시 북구",
  },
  {
    name: "광주광역시캣맘협의회",
    code: "329362202200002",
    org_cd: "3620000",
    org_Nm: "광주광역시 북구",
  },
  {
    name: "광주 동물보호소",
    code: "329360201300001",
    org_cd: "3600000",
    org_Nm: "광주광역시 서구",
  },
  {
    name: "광주광역시캣맘협의회",
    code: "329360201900001",
    org_cd: "3600000",
    org_Nm: "광주광역시 서구",
  },
  {
    name: "대구유기동물보호협회",
    code: "327344201600001",
    org_cd: "3440000",
    org_Nm: "대구광역시 남구",
  },
  {
    name: "(사)대구시수의사회",
    code: "327344202100001",
    org_cd: "3440000",
    org_Nm: "대구광역시 남구",
  },
  {
    name: "대구유기동물보호협회",
    code: "327347201400001",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "세림종합동물병원",
    code: "327347202100008",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "본리종합동물병원",
    code: "327347202100009",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "온누리동물병원",
    code: "327347202100002",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "초록동물병원",
    code: "327347202100004",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "애플동물병원",
    code: "327347202100006",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "대구광역시수의사회",
    code: "327347202100001",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "두류동물병원",
    code: "327347202100003",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "어진종합동물병원",
    code: "327347202100005",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "수목원동물병원",
    code: "327347202100007",
    org_cd: "3470000",
    org_Nm: "대구광역시 달서구",
  },
  {
    name: "대구수의사회(달성군)",
    code: "327348201300001",
    org_cd: "3480000",
    org_Nm: "대구광역시 달성군",
  },
  {
    name: "화원연합동물병원",
    code: "327348201500004",
    org_cd: "3480000",
    org_Nm: "대구광역시 달성군",
  },
  {
    name: "포산동물병원",
    code: "327348201500001",
    org_cd: "3480000",
    org_Nm: "대구광역시 달성군",
  },
  {
    name: "현풍동물병원",
    code: "327348201500002",
    org_cd: "3480000",
    org_Nm: "대구광역시 달성군",
  },
  {
    name: "달성축산동물병원",
    code: "327348201500003",
    org_cd: "3480000",
    org_Nm: "대구광역시 달성군",
  },
  {
    name: "동인동물병원",
    code: "327348201700001",
    org_cd: "3480000",
    org_Nm: "대구광역시 달성군",
  },
  {
    name: "명곡역동물병원",
    code: "327348201700004",
    org_cd: "3480000",
    org_Nm: "대구광역시 달성군",
  },
  {
    name: "119동물병원",
    code: "327348201700003",
    org_cd: "3480000",
    org_Nm: "대구광역시 달성군",
  },
  {
    name: "(재)한국동물보호협회",
    code: "327342201100001",
    org_cd: "3420000",
    org_Nm: "대구광역시 동구",
  },
  {
    name: "대구유기동물보호센터",
    code: "327342201400001",
    org_cd: "3420000",
    org_Nm: "대구광역시 동구",
  },
  {
    name: "다사랑종합동물병원",
    code: "327342202100001",
    org_cd: "3420000",
    org_Nm: "대구광역시 동구",
  },
  {
    name: "율하동물병원",
    code: "327342202100002",
    org_cd: "3420000",
    org_Nm: "대구광역시 동구",
  },
  {
    name: "대구시수의사회",
    code: "327342202100004",
    org_cd: "3420000",
    org_Nm: "대구광역시 동구",
  },
  {
    name: "앨리스동물병원",
    code: "327342202100003",
    org_cd: "3420000",
    org_Nm: "대구광역시 동구",
  },
  {
    name: "대구유기동물보호협회",
    code: "327345201400001",
    org_cd: "3450000",
    org_Nm: "대구광역시 북구",
  },
  {
    name: "대구광역시 수의사회",
    code: "327345202100001",
    org_cd: "3450000",
    org_Nm: "대구광역시 북구",
  },
  {
    name: "대구시수의사회(삼성)",
    code: "327343201500001",
    org_cd: "3430000",
    org_Nm: "대구광역시 서구",
  },
  {
    name: "대구시수의사회(보경)",
    code: "327343201500003",
    org_cd: "3430000",
    org_Nm: "대구광역시 서구",
  },
  {
    name: "대구시수의사회(평리)",
    code: "327343201500005",
    org_cd: "3430000",
    org_Nm: "대구광역시 서구",
  },
  {
    name: "대구시수의사회(더펫)",
    code: "327343201900001",
    org_cd: "3430000",
    org_Nm: "대구광역시 서구",
  },
  {
    name: "대구수의사회(아이펫)",
    code: "327343201500004",
    org_cd: "3430000",
    org_Nm: "대구광역시 서구",
  },
  {
    name: "제니스동물병원",
    code: "327346201500009",
    org_cd: "3460000",
    org_Nm: "대구광역시 수성구",
  },
  {
    name: "(사)대구수의사회",
    code: "327346201500001",
    org_cd: "3460000",
    org_Nm: "대구광역시 수성구",
  },
  {
    name: "예스동물병원",
    code: "327346201500015",
    org_cd: "3460000",
    org_Nm: "대구광역시 수성구",
  },
  {
    name: "허동물병원",
    code: "327346201800001",
    org_cd: "3460000",
    org_Nm: "대구광역시 수성구",
  },
  {
    name: "금강동물병원",
    code: "327346201800002",
    org_cd: "3460000",
    org_Nm: "대구광역시 수성구",
  },
  {
    name: "펫동물병원",
    code: "327346201900001",
    org_cd: "3460000",
    org_Nm: "대구광역시 수성구",
  },
  {
    name: "감자동물병원",
    code: "327346202100001",
    org_cd: "3460000",
    org_Nm: "대구광역시 수성구",
  },
  {
    name: "(사)대구시수의사회",
    code: "327341200900001",
    org_cd: "3410000",
    org_Nm: "대구광역시 수성구",
  },
  {
    name: "대구시수의사회(동산)",
    code: "327341201200004",
    org_cd: "3410000",
    org_Nm: "대구광역시 중구",
  },
  {
    name: "대구시수의사회(동인)",
    code: "327341201200001",
    org_cd: "3410000",
    org_Nm: "대구광역시 중구",
  },
  {
    name: "대구시수의사회(삼덕)",
    code: "327341201200002",
    org_cd: "3410000",
    org_Nm: "대구광역시 중구",
  },
  {
    name: "대구시수의사회(원)",
    code: "327341201900001",
    org_cd: "3410000",
    org_Nm: "대구광역시 중구",
  },
  {
    name: "대전동물보호센터",
    code: "330368202000001",
    org_cd: "3680000",
    org_Nm: "대전광역시 대덕구",
  },
  {
    name: "대전동물보호센터",
    code: "330364202000001",
    org_cd: "3640000",
    org_Nm: "대전광역시 동구",
  },
  {
    name: "대전동물보호센터",
    code: "330366202000001",
    org_cd: "3660000",
    org_Nm: "대전광역시 서구",
  },
  {
    name: "대전동물보호센터",
    code: "330367200900001",
    org_cd: "3670000",
    org_Nm: "대전광역시 유성구",
  },
  {
    name: "대전동물보호센터",
    code: "330365202000001",
    org_cd: "3650000",
    org_Nm: "대전광역시 중구",
  },
  {
    name: "(사)하얀비둘기",
    code: "326336202200001",
    org_cd: "3360000",
    org_Nm: "부산광역시 강서구",
  },
  {
    name: "누리동물병원",
    code: "326335201700001",
    org_cd: "3350000",
    org_Nm: "부산광역시 금정구",
  },
  {
    name: "누리동물병원",
    code: "326340201100001",
    org_cd: "3400000",
    org_Nm: "부산광역시 기장군",
  },
  {
    name: "누리동물병원",
    code: "326331201100001",
    org_cd: "3310000",
    org_Nm: "부산광역시 남구",
  },
  {
    name: "사단법인 하얀비둘기",
    code: "326327201900002",
    org_cd: "3270000",
    org_Nm: "부산광역시 동구",
  },
  {
    name: "누리동물병원",
    code: "326330201300001",
    org_cd: "3300000",
    org_Nm: "부산광역시 동래구",
  },
  {
    name: "동물보호관리협회",
    code: "326329201700001",
    org_cd: "3290000",
    org_Nm: "부산광역시 부산진구",
  },
  {
    name: "부산동물보호센터",
    code: "326332201000001",
    org_cd: "3320000",
    org_Nm: "부산광역시 북구",
  },
  {
    name: "(사)유기동물및동물보호관리협회",
    code: "326339201300001",
    org_cd: "3390000",
    org_Nm: "부산광역시 사상구",
  },
  {
    name: "(사)하얀비둘기",
    code: "326334202100001",
    org_cd: "3340000",
    org_Nm: "부산광역시 사하구",
  },
  {
    name: "부산동물보호센터",
    code: "326326201000001",
    org_cd: "3260000",
    org_Nm: "부산광역시 서구",
  },
  {
    name: "누리동물병원",
    code: "326338201300001",
    org_cd: "3380000",
    org_Nm: "부산광역시 수영구",
  },
  {
    name: "창조동물병원",
    code: "326337201300001",
    org_cd: "3370000",
    org_Nm: "부산광역시 연제구",
  },
  {
    name: "하얀비둘기",
    code: "326328201900001",
    org_cd: "3280000",
    org_Nm: "부산광역시 영도구",
  },
  {
    name: "부산동물보호센터",
    code: "326325201300001",
    org_cd: "3250000",
    org_Nm: "부산광역시 중구",
  },
  {
    name: "누리동물병원",
    code: "326333201100001",
    org_cd: "3330000",
    org_Nm: "부산광역시 해운대구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311322200900001",
    org_cd: "3220000",
    org_Nm: "서울특별시 강남구",
  },
  {
    name: "우리동물병원생명사회",
    code: "311322202000001",
    org_cd: "3220000",
    org_Nm: "서울특별시 강남구",
  },
  {
    name: "사랑이있는동물병원",
    code: "311322202100003",
    org_cd: "3220000",
    org_Nm: "서울특별시 강남구",
  },
  {
    name: "영국동물병원",
    code: "311322202100004",
    org_cd: "3220000",
    org_Nm: "서울특별시 강남구",
  },
  {
    name: "GD동물병원",
    code: "311324201600004",
    org_cd: "3240000",
    org_Nm: "서울특별시 강동구",
  },
  {
    name: "둔촌동물병원",
    code: "311324201600002",
    org_cd: "3240000",
    org_Nm: "서울특별시 강동구",
  },
  {
    name: "강동구청 반려동물팀",
    code: "311324201600001",
    org_cd: "3240000",
    org_Nm: "서울특별시 강동구",
  },
  {
    name: "강동리본센터(reborn)",
    code: "311324201700002",
    org_cd: "3240000",
    org_Nm: "서울특별시 강동구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311324201200001",
    org_cd: "3240000",
    org_Nm: "서울특별시 강동구",
  },
  {
    name: "가람동물병원",
    code: "311324202200001",
    org_cd: "3240000",
    org_Nm: "서울특별시 강동구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311308201100001",
    org_cd: "3080000",
    org_Nm: "서울특별시 강북구",
  },
  {
    name: "화신종합동물병원",
    code: "311308201900002",
    org_cd: "3080000",
    org_Nm: "서울특별시 강북구",
  },
  {
    name: "애니케어동물병원",
    code: "311308202200001",
    org_cd: "3080000",
    org_Nm: "서울특별시 강북구",
  },
  {
    name: "강북동물병원",
    code: "311308202200002",
    org_cd: "3080000",
    org_Nm: "서울특별시 강북구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311315200900001",
    org_cd: "3150000",
    org_Nm: "서울특별시 강서구",
  },
  {
    name: "러브펫종합동물병원",
    code: "311320201300001",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "비타민동물병원",
    code: "311320201700004",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "한성동물병원",
    code: "311320201700001",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "세계로동물병원",
    code: "311320201900001",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "프렌즈동물병원",
    code: "311320201800001",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "관악TNRDAY",
    code: "311320201800002",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "예일동물병원",
    code: "311320202000001",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "서울동물복지지원센터",
    code: "311320202100001",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "강현림동물병원",
    code: "311320202100002",
    org_cd: "3200000",
    org_Nm: "서울특별시 관악구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311304200900003",
    org_cd: "3040000",
    org_Nm: "서울특별시 광진구",
  },
  {
    name: "이다종합동물병원",
    code: "311304201800001",
    org_cd: "3040000",
    org_Nm: "서울특별시 광진구",
  },
  {
    name: "보람동물병원",
    code: "311304202100001",
    org_cd: "3040000",
    org_Nm: "서울특별시 광진구",
  },
  {
    name: "사랑이있는동물병원",
    code: "311304202100002",
    org_cd: "3040000",
    org_Nm: "서울특별시 광진구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311316201100001",
    org_cd: "3160000",
    org_Nm: "서울특별시 구로구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311317201400001",
    org_cd: "3170000",
    org_Nm: "서울특별시 금천구",
  },
  {
    name: "금천TNRDAY",
    code: "311317201800002",
    org_cd: "3170000",
    org_Nm: "서울특별시 금천구",
  },
  {
    name: "190519TNRDAY",
    code: "311317201900002",
    org_cd: "3170000",
    org_Nm: "서울특별시 금천구",
  },
  {
    name: "은행나무종합동물병원",
    code: "311317202200001",
    org_cd: "3170000",
    org_Nm: "서울특별시 금천구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311310201000001",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "시마동물병원",
    code: "311310201400002",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "25시동물병원",
    code: "311310201400001",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "노원 TNR DAY",
    code: "311310201700001",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "이n김동물병원",
    code: "311310202100001",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "러브펫(상계점)",
    code: "311310202000001",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "엔젤동물병원",
    code: "311310202000003",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "노원반려동물문화센터",
    code: "311310202000004",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "러브펫(공릉점)",
    code: "311310202000002",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "서울동물복지지원센터",
    code: "311310202200001",
    org_cd: "3100000",
    org_Nm: "서울특별시 노원구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311309200900001",
    org_cd: "3090000",
    org_Nm: "서울특별시 도봉구",
  },
  {
    name: "김미경동물병원",
    code: "311309202200002",
    org_cd: "3090000",
    org_Nm: "서울특별시 도봉구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311305201300001",
    org_cd: "3050000",
    org_Nm: "서울특별시 동대문구",
  },
  {
    name: "푸른종합동물병원",
    code: "311305201600002",
    org_cd: "3050000",
    org_Nm: "서울특별시 동대문구",
  },
  {
    name: "주주동물병원",
    code: "311305201800002",
    org_cd: "3050000",
    org_Nm: "서울특별시 동대문구",
  },
  {
    name: "박철환동물병원",
    code: "311305202000001",
    org_cd: "3050000",
    org_Nm: "서울특별시 동대문구",
  },
  {
    name: "동대문구청",
    code: "311305202100001",
    org_cd: "3050000",
    org_Nm: "서울특별시 동대문구",
  },
  {
    name: "디아크동물종합병원",
    code: "311319201200001",
    org_cd: "3190000",
    org_Nm: "서울특별시 동작구",
  },
  {
    name: "20181014TNR데이",
    code: "311319201800003",
    org_cd: "3190000",
    org_Nm: "서울특별시 동작구",
  },
  {
    name: "디아크종합동물병원",
    code: "311319201800001",
    org_cd: "3190000",
    org_Nm: "서울특별시 동작구",
  },
  {
    name: "20190519TNRDAY",
    code: "311319201900001",
    org_cd: "3190000",
    org_Nm: "서울특별시 동작구",
  },
  {
    name: "박창석동물병원",
    code: "311313201000006",
    org_cd: "3130000",
    org_Nm: "서울특별시 마포구",
  },
  {
    name: "홍익동물병원",
    code: "311313201000017",
    org_cd: "3130000",
    org_Nm: "서울특별시 마포구",
  },
  {
    name: "웰케어 동물병원",
    code: "311313201300003",
    org_cd: "3130000",
    org_Nm: "서울특별시 마포구",
  },
  {
    name: "마포TNRDAY",
    code: "311313201800003",
    org_cd: "3130000",
    org_Nm: "서울특별시 마포구",
  },
  {
    name: "C.T종합동물병원",
    code: "311313202000001",
    org_cd: "3130000",
    org_Nm: "서울특별시 마포구",
  },
  {
    name: "마포구청",
    code: "311313202000003",
    org_cd: "3130000",
    org_Nm: "서울특별시 마포구",
  },
  {
    name: "월드펫동물병원",
    code: "311313202000002",
    org_cd: "3130000",
    org_Nm: "서울특별시 마포구",
  },
  {
    name: "서울동물복지지원센터",
    code: "311313202100001",
    org_cd: "3130000",
    org_Nm: "서울특별시 마포구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311312201100001",
    org_cd: "3120000",
    org_Nm: "서울특별시 서대문구",
  },
  {
    name: "신영동물병원",
    code: "311312201400001",
    org_cd: "3120000",
    org_Nm: "서울특별시 서대문구",
  },
  {
    name: "한동물병원",
    code: "311321201400005",
    org_cd: "3210000",
    org_Nm: "서울특별시 서초구",
  },
  {
    name: "20181014TNR데이",
    code: "311321201800003",
    org_cd: "3210000",
    org_Nm: "서울특별시 서초구",
  },
  {
    name: "서초동물사랑센터",
    code: "311321201800002",
    org_cd: "3210000",
    org_Nm: "서울특별시 서초구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311321201400004",
    org_cd: "3210000",
    org_Nm: "서울특별시 서초구",
  },
  {
    name: "내방동물병원",
    code: "311321202000002",
    org_cd: "3210000",
    org_Nm: "서울특별시 서초구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311303200900001",
    org_cd: "3030000",
    org_Nm: "서울특별시 성동구",
  },
  {
    name: "한빛동물병원",
    code: "311303202000002",
    org_cd: "3030000",
    org_Nm: "서울특별시 성동구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311307200900001",
    org_cd: "3070000",
    org_Nm: "서울특별시 성북구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311323201100001",
    org_cd: "3230000",
    org_Nm: "서울특별시 송파구",
  },
  {
    name: "잠실종합동물병원",
    code: "311323202200001",
    org_cd: "3230000",
    org_Nm: "서울특별시 송파구",
  },
  {
    name: "둔촌동물병원",
    code: "311323202200004",
    org_cd: "3230000",
    org_Nm: "서울특별시 송파구",
  },
  {
    name: "강현림동물병원",
    code: "311314201000001",
    org_cd: "3140000",
    org_Nm: "서울특별시 양천구",
  },
  {
    name: "양천TNRDAY",
    code: "311314201800001",
    org_cd: "3140000",
    org_Nm: "서울특별시 양천구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311318201200001",
    org_cd: "3180000",
    org_Nm: "서울특별시 영등포구",
  },
  {
    name: "참동물병원",
    code: "311318201600002",
    org_cd: "3180000",
    org_Nm: "서울특별시 영등포구",
  },
  {
    name: "I-pet 동물병원",
    code: "311318201700003",
    org_cd: "3180000",
    org_Nm: "서울특별시 영등포구",
  },
  {
    name: "21세기동물병원",
    code: "311302201000003",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "이태원동물병원",
    code: "311302201000005",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "열린동물병원",
    code: "311302201000006",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "보광동물병원",
    code: "311302201000007",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "차오름동물병원",
    code: "311302201000013",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "남산동물병원",
    code: "311302201000020",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "금강동물병원",
    code: "311302201000019",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "원효동물병원",
    code: "311302201000008",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "이상윤동물병원",
    code: "311302201000014",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "효창동물병원",
    code: "311302201000002",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "청화동물병원",
    code: "311302201000011",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "라온동물병원",
    code: "311302201000018",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "민트동물병원",
    code: "311302201400001",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "펫토이동물병원",
    code: "311302201000012",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "한남동물병원",
    code: "311302201000004",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "서울동물복지지원센터",
    code: "311302202100001",
    org_cd: "3020000",
    org_Nm: "서울특별시 용산구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311311201100001",
    org_cd: "3110000",
    org_Nm: "서울특별시 은평구",
  },
  {
    name: "우리동물병원생명사회",
    code: "311311202000001",
    org_cd: "3110000",
    org_Nm: "서울특별시 은평구",
  },
  {
    name: "서울동물복지지원센터",
    code: "311311202200001",
    org_cd: "3110000",
    org_Nm: "서울특별시 은평구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311300201300001",
    org_cd: "3000000",
    org_Nm: "서울특별시 종로구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311301201000001",
    org_cd: "3010000",
    org_Nm: "서울특별시 중구",
  },
  {
    name: "웰펫동물병원",
    code: "311301201800001",
    org_cd: "3010000",
    org_Nm: "서울특별시 중구",
  },
  {
    name: "한국동물구조관리협회",
    code: "311306201300001",
    org_cd: "3060000",
    org_Nm: "서울특별시 중랑구",
  },
  {
    name: "사랑이 있는 동물병원",
    code: "311306202000002",
    org_cd: "3060000",
    org_Nm: "서울특별시 중랑구",
  },
  {
    name: "서울동물복지지원센터",
    code: "311306202200001",
    org_cd: "3060000",
    org_Nm: "서울특별시 중랑구",
  },
  {
    name: "세종종합동물병원",
    code: "369569201900001",
    org_cd: "5690000",
    org_Nm: "세종특별자치시",
  },
  {
    name: "리얼펫동물병원",
    code: "369569202000003",
    org_cd: "5690000",
    org_Nm: "세종특별자치시",
  },
  {
    name: "세종유기동물보호센터",
    code: "369569202000001",
    org_cd: "5690000",
    org_Nm: "세종특별자치시",
  },
  {
    name: "미래펫동물병원",
    code: "331370200900003",
    org_cd: "3700000",
    org_Nm: "울산광역시 남구",
  },
  {
    name: "사랑동물병원",
    code: "331370200900001",
    org_cd: "3700000",
    org_Nm: "울산광역시 남구",
  },
  {
    name: "스마일동물병원",
    code: "331370201200001",
    org_cd: "3700000",
    org_Nm: "울산광역시 남구",
  },
  {
    name: "울산유기동물보호센터",
    code: "331370201200003",
    org_cd: "3700000",
    org_Nm: "울산광역시 남구",
  },
  {
    name: "리틀쥬동물의료원",
    code: "331370201600002",
    org_cd: "3700000",
    org_Nm: "울산광역시 남구",
  },
  {
    name: "강남동물병원",
    code: "331370201800001",
    org_cd: "3700000",
    org_Nm: "울산광역시 남구",
  },
  {
    name: "주동물병원",
    code: "331370202000001",
    org_cd: "3700000",
    org_Nm: "울산광역시 남구",
  },
  {
    name: "일산동물의료센터",
    code: "331371201000001",
    org_cd: "3710000",
    org_Nm: "울산광역시 동구",
  },
  {
    name: "울산유기동물보호센터",
    code: "331371201200001",
    org_cd: "3710000",
    org_Nm: "울산광역시 동구",
  },
  {
    name: "이솝동물병원",
    code: "331372200900002",
    org_cd: "3720000",
    org_Nm: "울산광역시 북구",
  },
  {
    name: "쿨펫동물병원",
    code: "331372200900003",
    org_cd: "3720000",
    org_Nm: "울산광역시 북구",
  },
  {
    name: "울산유기동물보호센터",
    code: "331372201200001",
    org_cd: "3720000",
    org_Nm: "울산광역시 북구",
  },
  {
    name: "쿨펫 홈플러스 북구점",
    code: "331372202000002",
    org_cd: "3720000",
    org_Nm: "울산광역시 북구",
  },
  {
    name: "정철동물병원",
    code: "331372202000001",
    org_cd: "3720000",
    org_Nm: "울산광역시 북구",
  },
  {
    name: "호계동물병원",
    code: "331372202200001",
    org_cd: "3720000",
    org_Nm: "울산광역시 북구",
  },
  {
    name: "잘하는동물메디컬센터",
    code: "331372202200002",
    org_cd: "3720000",
    org_Nm: "울산광역시 북구",
  },
  {
    name: "울산유기동물보호센터",
    code: "331373201200002",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "와우동물병원",
    code: "331373201200001",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "온양 발리동물병원",
    code: "331373201600003",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "범서조은동물병원",
    code: "331373201600001",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "와우동물병원",
    code: "331373201600005",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "초록동물병원",
    code: "331373201600002",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "남창미르동물병원",
    code: "331373201600006",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "BB동물병원",
    code: "331373201600007",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "MK동물병원",
    code: "331373201600008",
    org_cd: "3730000",
    org_Nm: "울산광역시 울주군",
  },
  {
    name: "울산유기동물보호센터",
    code: "331369201400003",
    org_cd: "3690000",
    org_Nm: "울산광역시 중구",
  },
  {
    name: "학성동물병원",
    code: "331369201900003",
    org_cd: "3690000",
    org_Nm: "울산광역시 중구",
  },
  {
    name: "산타클라라동물병원",
    code: "331369201900001",
    org_cd: "3690000",
    org_Nm: "울산광역시 중구",
  },
  {
    name: "울산동물병원",
    code: "331369200900004",
    org_cd: "3690000",
    org_Nm: "울산광역시 중구",
  },
  {
    name: "라온동물메디컬센터",
    code: "331369201900005",
    org_cd: "3690000",
    org_Nm: "울산광역시 중구",
  },
  {
    name: "쿨펫동물병원",
    code: "331369201900004",
    org_cd: "3690000",
    org_Nm: "울산광역시 중구",
  },
  {
    name: "메이동물병원",
    code: "331369201900006",
    org_cd: "3690000",
    org_Nm: "울산광역시 중구",
  },
  {
    name: "제갈견동물병원",
    code: "331369202100001",
    org_cd: "3690000",
    org_Nm: "울산광역시 중구",
  },
  {
    name: "베스트동물병원",
    code: "328357200900001",
    org_cd: "3570000",
    org_Nm: "인천광역시 강화군",
  },
  {
    name: "서울동물병원",
    code: "328357201700001",
    org_cd: "3570000",
    org_Nm: "인천광역시 강화군",
  },
  {
    name: "Dr.G동물병원",
    code: "328357202200001",
    org_cd: "3570000",
    org_Nm: "인천광역시 강화군",
  },
  {
    name: "인천수의사회유기동물",
    code: "328357202200003",
    org_cd: "3570000",
    org_Nm: "인천광역시 강화군",
  },
  {
    name: "신영재동물병원",
    code: "328355200900001",
    org_cd: "3550000",
    org_Nm: "인천광역시 계양구",
  },
  {
    name: "계산동물병원",
    code: "328355202100004",
    org_cd: "3550000",
    org_Nm: "인천광역시 계양구",
  },
  {
    name: "다오동물병원",
    code: "328355202100001",
    org_cd: "3550000",
    org_Nm: "인천광역시 계양구",
  },
  {
    name: "아마존동물병원",
    code: "328355202100003",
    org_cd: "3550000",
    org_Nm: "인천광역시 계양구",
  },
  {
    name: "인천광역시수의사회",
    code: "328353200900001",
    org_cd: "3530000",
    org_Nm: "인천광역시 남동구",
  },
  {
    name: "경동동물병원",
    code: "328350202100001",
    org_cd: "3500000",
    org_Nm: "인천광역시 동구",
  },
  {
    name: "인천광역시수의사회",
    code: "328351200900001",
    org_cd: "3510500",
    org_Nm: "인천광역시 미추홀구",
  },
  {
    name: "늘푸른동물병원",
    code: "328354201700002",
    org_cd: "3540000",
    org_Nm: "인천광역시 부평구",
  },
  {
    name: "세림동물병원",
    code: "328354201600001",
    org_cd: "3540000",
    org_Nm: "인천광역시 부평구",
  },
  {
    name: "삼산종합동물병원",
    code: "328354201700003",
    org_cd: "3540000",
    org_Nm: "인천광역시 부평구",
  },
  {
    name: "짱구네동물병원",
    code: "328354201900001",
    org_cd: "3540000",
    org_Nm: "인천광역시 부평구",
  },
  {
    name: "조재진동물병원",
    code: "328354202000001",
    org_cd: "3540000",
    org_Nm: "인천광역시 부평구",
  },
  {
    name: "가정동물병원",
    code: "328356201000001",
    org_cd: "3560000",
    org_Nm: "인천광역시 서구",
  },
  {
    name: "우리동물병원",
    code: "328356201600005",
    org_cd: "3560000",
    org_Nm: "인천광역시 서구",
  },
  {
    name: "진현우동물병원",
    code: "328356202100001",
    org_cd: "3560000",
    org_Nm: "인천광역시 서구",
  },
  {
    name: "가온동물의료센터",
    code: "328356202200002",
    org_cd: "3560000",
    org_Nm: "인천광역시 서구",
  },
  {
    name: "펫홈동물병원",
    code: "328356202200001",
    org_cd: "3560000",
    org_Nm: "인천광역시 서구",
  },
  {
    name: "인천광역시수의사회",
    code: "328352201400001",
    org_cd: "3520000",
    org_Nm: "인천광역시 연수구",
  },
  {
    name: "인천수의사회유기동물",
    code: "328358201000001",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "현대종합동물병원",
    code: "328358202100001",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "필종합동물병원",
    code: "328358202100002",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "참동물병원",
    code: "328358202100003",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "연수동물메디컬센터",
    code: "328358202100005",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "시민동물병원",
    code: "328358202100006",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "삼산종합동물병원",
    code: "328358202100008",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "짱구네동물병원",
    code: "328358202100004",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "시드니종합동물병원",
    code: "328358202100007",
    org_cd: "3580000",
    org_Nm: "인천광역시 옹진군",
  },
  {
    name: "경동동물병원",
    code: "328349201000001",
    org_cd: "3490000",
    org_Nm: "인천광역시 중구",
  },
  {
    name: "신공항동물병원",
    code: "328349201500001",
    org_cd: "3490000",
    org_Nm: "인천광역시 중구",
  },
  {
    name: "강진군 유기견 보호소",
    code: "346492201300001",
    org_cd: "4920000",
    org_Nm: "전라남도 강진군",
  },
  {
    name: "고흥군임시보호센터",
    code: "346488201700001",
    org_cd: "4880000",
    org_Nm: "전라남도 고흥군",
  },
  {
    name: "푸른곡성21동물보호소",
    code: "346486201600001",
    org_cd: "4860000",
    org_Nm: "전라남도 곡성군",
  },
  {
    name: "광양시 임시보호소",
    code: "346484201900001",
    org_cd: "4840000",
    org_Nm: "전라남도 광양시",
  },
  {
    name: "구례군동물보호센터",
    code: "346487201800001",
    org_cd: "4870000",
    org_Nm: "전라남도 구례군",
  },
  {
    name: "나주유기동물보호센터",
    code: "346483202100001",
    org_cd: "4830000",
    org_Nm: "전라남도 나주시",
  },
  {
    name: "벤지동물병원",
    code: "346483202300001",
    org_cd: "4830000",
    org_Nm: "전라남도 나주시",
  },
  {
    name: "담양군 동물보호센터",
    code: "346485201800001",
    org_cd: "4850000",
    org_Nm: "전라남도 담양군",
  },
  {
    name: "목포시유기동물보호소",
    code: "346480201000001",
    org_cd: "4800000",
    org_Nm: "전라남도 목포시",
  },
  {
    name: "무안군유기동물보호소",
    code: "346495202100001",
    org_cd: "4950000",
    org_Nm: "전라남도 무안군",
  },
  {
    name: "보성유기동물보호센터",
    code: "346489202000001",
    org_cd: "4890000",
    org_Nm: "전라남도 보성군",
  },
  {
    name: "대한동물사랑협회",
    code: "346482201400002",
    org_cd: "4820000",
    org_Nm: "전라남도 순천시",
  },
  {
    name: "순천시유기동물보호소",
    code: "346482201600003",
    org_cd: "4820000",
    org_Nm: "전라남도 순천시",
  },
  {
    name: "신안군유기동물보호소",
    code: "346501201700001",
    org_cd: "5010000",
    org_Nm: "전라남도 신안군",
  },
  {
    name: "유기동물보호소",
    code: "346481200900001",
    org_cd: "4810000",
    org_Nm: "전라남도 여수시",
  },
  {
    name: "불갑동물임시보호소",
    code: "346497201300001",
    org_cd: "4970000",
    org_Nm: "전라남도 영광군",
  },
  {
    name: "유기동물 삼호 보호소",
    code: "346494201700001",
    org_cd: "4940000",
    org_Nm: "전라남도 영암군",
  },
  {
    name: "유기동물임시보호센터",
    code: "346499201300001",
    org_cd: "4990000",
    org_Nm: "전라남도 완도군",
  },
  {
    name: "장성군동물보호센터",
    code: "346498202000001",
    org_cd: "4980000",
    org_Nm: "전라남도 장성군",
  },
  {
    name: "장흥군 동물보호센터",
    code: "346491201300001",
    org_cd: "4910000",
    org_Nm: "전라남도 장흥군",
  },
  {
    name: "진도개메디컬센터",
    code: "346500201300001",
    org_cd: "5000000",
    org_Nm: "전라남도 진도군",
  },
  {
    name: "학교동물임시보호센터",
    code: "346496201800001",
    org_cd: "4960000",
    org_Nm: "전라남도 함평군",
  },
  {
    name: "해남군임시동물보호소",
    code: "346493200900001",
    org_cd: "4930000",
    org_Nm: "전라남도 해남군",
  },
  {
    name: "화순군유기동물보호소",
    code: "346490202000001",
    org_cd: "4900000",
    org_Nm: "전라남도 화순군",
  },
  {
    name: "더나은동물병원보호소",
    code: "345478202200001",
    org_cd: "4780000",
    org_Nm: "전라북도 고창군",
  },
  {
    name: "군산유기동물보호센터",
    code: "345467201000001",
    org_cd: "4670000",
    org_Nm: "전라북도 군산시",
  },
  {
    name: "묘연쉼터",
    code: "345467202000003",
    org_cd: "4670000",
    org_Nm: "전라북도 군산시",
  },
  {
    name: "전북말산업복합센터",
    code: "345471201800002",
    org_cd: "4710000",
    org_Nm: "전라북도 김제시",
  },
  {
    name: "청원동물병원",
    code: "345470200900001",
    org_cd: "4700000",
    org_Nm: "전라북도 남원시",
  },
  {
    name: "하나동물병원",
    code: "345470201300002",
    org_cd: "4700000",
    org_Nm: "전라북도 남원시",
  },
  {
    name: "인월동물병원",
    code: "345470202100001",
    org_cd: "4700000",
    org_Nm: "전라북도 남원시",
  },
  {
    name: "무주군",
    code: "345474200900001",
    org_cd: "4740000",
    org_Nm: "전라북도 무주군",
  },
  {
    name: "연합동물병원",
    code: "345479201600002",
    org_cd: "4790000",
    org_Nm: "전라북도 부안군",
  },
  {
    name: "부안군 동물보호센터",
    code: "345479202100001",
    org_cd: "4790000",
    org_Nm: "전라북도 부안군",
  },
  {
    name: "미래동물병원",
    code: "345479202200002",
    org_cd: "4790000",
    org_Nm: "전라북도 부안군",
  },
  {
    name: "닥터홍동물병원",
    code: "345479202200003",
    org_cd: "4790000",
    org_Nm: "전라북도 부안군",
  },
  {
    name: "순창유기동물보호소",
    code: "345477202000001",
    org_cd: "4770000",
    org_Nm: "전라북도 순창군",
  },
  {
    name: "도담",
    code: "345472202200001",
    org_cd: "4720000",
    org_Nm: "전라북도 완주군",
  },
  {
    name: "완주군유기동물보호소",
    code: "345472202300001",
    org_cd: "4720000",
    org_Nm: "전라북도 완주군",
  },
  {
    name: "익산유기동물보호소",
    code: "345468201200001",
    org_cd: "4680000",
    org_Nm: "전라북도 익산시",
  },
  {
    name: "하루동물병원",
    code: "345476202200001",
    org_cd: "4760000",
    org_Nm: "전라북도 임실군",
  },
  {
    name: "임실유기동물보호센터",
    code: "345476202100001",
    org_cd: "4760000",
    org_Nm: "전라북도 임실군",
  },
  {
    name: "제이준동물병원",
    code: "345475202200001",
    org_cd: "4750000",
    org_Nm: "전라북도 장수군",
  },
  {
    name: "도담",
    code: "345475202200002",
    org_cd: "4750000",
    org_Nm: "전라북도 장수군",
  },
  {
    name: "장수군 보호소",
    code: "345475202200003",
    org_cd: "4750000",
    org_Nm: "전라북도 장수군",
  },
  {
    name: "프렌즈동물병원",
    code: "345464200900001",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "21세기동물병원",
    code: "345464201100009",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "행복한동물병원",
    code: "345464201200001",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "박영재동물병원",
    code: "345464201100001",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "아프리카동물병원",
    code: "345464201100011",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "서신동물병원",
    code: "345464201100003",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "동부동물병원",
    code: "345464201100004",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "하나동물병원",
    code: "345464201300003",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "늘푸른동물병원",
    code: "345464201700001",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "효자동물병원",
    code: "345464202200001",
    org_cd: "4640000",
    org_Nm: "전라북도 전주시",
  },
  {
    name: "정읍시 동물보호소",
    code: "345469202000001",
    org_cd: "4690000",
    org_Nm: "전라북도 정읍시",
  },
  {
    name: "진안군유기동물보호소",
    code: "345473202300001",
    org_cd: "4730000",
    org_Nm: "전라북도 진안군",
  },
  {
    name: "계룡시유기동물보호소",
    code: "344558201300001",
    org_cd: "5580000",
    org_Nm: "충청남도 계룡시",
  },
  {
    name: "금비동물병원",
    code: "344558202200001",
    org_cd: "5580000",
    org_Nm: "충청남도 계룡시",
  },
  {
    name: "강북동물병원",
    code: "344450201500001",
    org_cd: "4500000",
    org_Nm: "충청남도 공주시",
  },
  {
    name: "공주시 동물보호소",
    code: "344450202200001",
    org_cd: "4500000",
    org_Nm: "충청남도 공주시",
  },
  {
    name: "우신동물병원",
    code: "344455201800001",
    org_cd: "4550000",
    org_Nm: "충청남도 금산군",
  },
  {
    name: "월드동물병원",
    code: "344455202100001",
    org_cd: "4550000",
    org_Nm: "충청남도 금산군",
  },
  {
    name: "하나동물병원",
    code: "344455202100002",
    org_cd: "4550000",
    org_Nm: "충청남도 금산군",
  },
  {
    name: "논산시 동물보호센터",
    code: "344454202000006",
    org_cd: "4540000",
    org_Nm: "충청남도 논산시",
  },
  {
    name: "당진시동물보호소",
    code: "344568201700001",
    org_cd: "5680000",
    org_Nm: "충청남도 당진시",
  },
  {
    name: "행담동물병원",
    code: "344568202000002",
    org_cd: "5680000",
    org_Nm: "충청남도 당진시",
  },
  {
    name: "현대동물병원",
    code: "344568202000001",
    org_cd: "5680000",
    org_Nm: "충청남도 당진시",
  },
  {
    name: "건국동물병원",
    code: "344568202000003",
    org_cd: "5680000",
    org_Nm: "충청남도 당진시",
  },
  {
    name: "보령시유기동물보호소",
    code: "344451201300001",
    org_cd: "4510000",
    org_Nm: "충청남도 보령시",
  },
  {
    name: "보령길고양이보호협회",
    code: "344451202200002",
    org_cd: "4510000",
    org_Nm: "충청남도 보령시",
  },
  {
    name: "남부여동물병원",
    code: "344457202000001",
    org_cd: "4570000",
    org_Nm: "충청남도 부여군",
  },
  {
    name: "서산시 동물보호센터",
    code: "344453202100003",
    org_cd: "4530000",
    org_Nm: "충청남도 서산시",
  },
  {
    name: "로얄동물병원",
    code: "344453202200001",
    org_cd: "4530000",
    org_Nm: "충청남도 서산시",
  },
  {
    name: "서천군유기동물보호소",
    code: "344458201300001",
    org_cd: "4580000",
    org_Nm: "충청남도 서천군",
  },
  {
    name: "서해동물병원",
    code: "344458202100002",
    org_cd: "4580000",
    org_Nm: "충청남도 서천군",
  },
  {
    name: "장동호 동물병원",
    code: "344458202100001",
    org_cd: "4580000",
    org_Nm: "충청남도 서천군",
  },
  {
    name: "아산시동물보호센터",
    code: "344452201600001",
    org_cd: "4520000",
    org_Nm: "충청남도 아산시",
  },
  {
    name: "아산동물복지지원센터",
    code: "344452202300001",
    org_cd: "4520000",
    org_Nm: "충청남도 아산시",
  },
  {
    name: "예산동물보호센터",
    code: "344461201900001",
    org_cd: "4610000",
    org_Nm: "충청남도 예산군",
  },
  {
    name: "(구)민간동물보호소",
    code: "344449201200001",
    org_cd: "4490000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "중앙동물병원",
    code: "344449201900001",
    org_cd: "4490000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "닥터전동물병원",
    code: "344449201900005",
    org_cd: "4490000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "디어마이프렌즈",
    code: "344449202000003",
    org_cd: "4490000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "천안시유기동물보호소",
    code: "344449202100001",
    org_cd: "4490000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "중부벳동물병원",
    code: "344449202100002",
    org_cd: "4490000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "엔젤동물병원",
    code: "344449202000004",
    org_cd: "4490000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "해맑은 동물병원",
    code: "344449202200001",
    org_cd: "4490000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "청양보호소",
    code: "344459202000001",
    org_cd: "4590000",
    org_Nm: "충청남도 청양군",
  },
  {
    name: "최동물병원",
    code: "344462200900001",
    org_cd: "4620000",
    org_Nm: "충청남도 태안군",
  },
  {
    name: "금일동물보호센터",
    code: "344460201300001",
    org_cd: "4600000",
    org_Nm: "충청남도 홍성군",
  },
  {
    name: "괴산증평동물보호센터",
    code: "343446201800002",
    org_cd: "4460000",
    org_Nm: "충청남도 천안시",
  },
  {
    name: "단양군유기동물보호소",
    code: "343448200900001",
    org_cd: "4480000",
    org_Nm: "충청북도 단양군",
  },
  {
    name: "최상오동물병원",
    code: "343442201300001",
    org_cd: "4420000",
    org_Nm: "충청북도 보은군",
  },
  {
    name: "더가까운동물병원",
    code: "343442202200001",
    org_cd: "4420000",
    org_Nm: "충청북도 보은군",
  },
  {
    name: "최종주동물병원",
    code: "343444200900002",
    org_cd: "4440000",
    org_Nm: "충청북도 영동군",
  },
  {
    name: "옥천동물병원",
    code: "343443201500001",
    org_cd: "4430000",
    org_Nm: "충청북도 옥천군",
  },
  {
    name: "금왕동물병원",
    code: "343447202000001",
    org_cd: "4470000",
    org_Nm: "충청북도 음성군",
  },
  {
    name: "제천시 동물보호센터",
    code: "343440201500002",
    org_cd: "4400000",
    org_Nm: "충청북도 제천시",
  },
  {
    name: "증평가정견훈련소",
    code: "343557201700001",
    org_cd: "5570000",
    org_Nm: "충청북도 증평군",
  },
  {
    name: "증평 가정견 훈련소",
    code: "343445202200001",
    org_cd: "4450000",
    org_Nm: "충청북도 증평군",
  },
  {
    name: "오수의과 동물병원",
    code: "343445202200002",
    org_cd: "4450000",
    org_Nm: "충청북도 증평군",
  },
  {
    name: "반려동물보호센터",
    code: "343571201600001",
    org_cd: "5710000",
    org_Nm: "충청북도 청주시",
  },
  {
    name: "충주시동물보호센터",
    code: "343439201700001",
    org_cd: "4390000",
    org_Nm: "충청북도 충주시",
  },
  {
    name: "제주 동물보호센터",
    code: "350650201200001",
    org_cd: "6500000",
    org_Nm: "제주특별자치도",
  },
];

export default shelterList;
